import { render, staticRenderFns } from "./TemplateHeader.vue?vue&type=template&id=1abb9b9e&scoped=true&"
import script from "./TemplateHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TemplateHeader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TemplateHeader.vue?vue&type=style&index=0&id=1abb9b9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb9b9e",
  null
  
)

export default component.exports